module.exports = __webpack_public_path__ + "img/play_arrow.456e4697.svg";